import request from '@/utils/request'
export const toSwitchUser = (v) => {
  let localMockData = localStorage.getItem('M_O_C_K')
  if (typeof localMockData !== 'string') {
    // 未走后门
    return
  }
  if (/\D+/.test(v) || !v) {
    // 不支持非数字
    console.error('请检查工号格式')
    return
  }
  try {
    localMockData = JSON.parse(localMockData)
  } catch (e) {
    console.log('解析失败，取默认')
  }
  if (!(localMockData instanceof Object)) {
    localMockData = {
      captchaCode: '123',
      loginType: 'qyWxCode',
      mockPassword: '157341e2df4c178cb8eecd2d04214c9f',
      password: '202cb962ac59075b964b07152d234b70',
      username: '21949'
    }
  }
  localMockData.username = v
  return request({
    url: 'wutong-idaas-auth/login',
    method: 'post',
    data: localMockData,
    headers: {
      // localStorage.getItem('tenantId')
      'TenantId': 'defaultTenantId',
      Authorization: undefined
    }
  }).then(({ data }) => {
    const authorization = data.Authorization
    if (!authorization) {
      console.log('mock失败')
      return
    }
    localStorage.setItem('TOKEN_KEY', authorization)
    location.reload()
  })
}
